import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import AssignedSectionQuery, {
	type AssignedSectionQuery as AssignedSectionQueryType,
} from '../assigned/__generated__/AssignedSectionQuery.graphql';

export const assignedSectionResource = createRelayResource<AssignedSectionQueryType>({
	getQuery: (_, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const accountId = context.user.accountId;
		const isAssignedFeedEnabled = fg('townsquare_enable_assigned_feed');

		return {
			environment: getAggRelayEnvironment(),
			query: AssignedSectionQuery,
			variables: {
				userId: `ari:cloud:identity::user/${accountId}`,
				isEnabled: isAssignedFeedEnabled,
			},
		};
	},
});
